import { useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useCheckMRDC } from "@/hooks/mrdc/use-check-mrdc";
import { useUpdateMRDC } from "@/hooks/mrdc/use-update-mrdc";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/providers/auth";
import { toast } from "react-toastify";

export default function CheckDepositConfirm() {
  const history = useHistory();
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const { mutate: updateDeposit, isLoading: updatingDeposit } = useUpdateMRDC();
  const { data } = useCheckMRDC({
    status: "",
    onError: (error) => {
      if (error?.response?.status === 404) {
        queryClient.setQueryData(["mrdc", ""], []);
      }
    },
  });

  const submittedDeposit = data?.find(
    (deposit) =>
      (deposit.status === "submitted" || deposit.status === "pending_review") &&
      deposit.user_confirmation === false
  );

  return (
    <AlertDialog open={user && submittedDeposit?.user_confirmation === false}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Your deposit was submitted!</AlertDialogTitle>
          <AlertDialogDescription>
            Your deposit was submitted successfully.{" "}
            <span>
              Please do not destroy the check until the funds have been
              desposited into your account.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            className="bg-green-600 hover:bg-green-600/70"
            disabled={updatingDeposit}
            onClick={() => {
              updateDeposit(
                {
                  id: submittedDeposit?.mrdc_id,
                  payload: {
                    user_confirmation: true,
                  },
                },
                {
                  onSuccess: () => {
                    queryClient.invalidateQueries(["invoices"]);
                    history.push("/invoices");
                  },
                  onError: (error) => {
                    // if (error?.response?.status === 410) {
                    //   return;
                    // }
                    queryClient.invalidateQueries(["mrdc"]);
                    toast.error(
                      "Uh oh. Something went wrong. Please try again.",
                      {
                        autoClose: 7000,
                      }
                    );
                  },
                }
              );
            }}
          >
            Confirm{" "}
            {updatingDeposit && (
              <Loader2 className="h-4 w-4 ml-2 animate-spin" />
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
